export default {
  light: '#F2F2F2',
  dark: '#434752',
  acidGreen: '#1FD75E',
};
